export { default } from './RootRef';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/RootRef/index.js
// module id = 349
// module chunks = 0